const inspectionList = {
  backbtn: "Geh zurück",
  inspectionList: "Inspektionsliste",
  search: "Suche",
  equipmentTag: "Ausrüstungs-Tag",
  customer: "Kunde",
  inspectionDate: "Inspektionsdatum"
};
export default inspectionList;
